import CustomDrawer from "../shared/CustomDrawer";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import DrawerActionItem from "../shared/DrawerActionItem";
import { ReactComponent as TrashIcon } from "../../assets/icons/trash-colored.svg";
import { ActionModal } from "../shared/ActionModal";
import { useState } from "react";

export function DeleteContractBottomSheet(props) {
  const { open, setOpen, id, getUserContract } = props;
  const [openModal, setOpenModal] = useState(false);
  const { loading, apiCall: deleteUserContract } = useRequest(
    BalootUserAPIs.deleteUserContract
  );

  const deleteContract = () => {
    deleteUserContract({
      data: { id },
      onSuccess: () => {
        getUserContract();
        setOpenModal(false);
        setOpen(false);
      },
    });
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DrawerActionItem
        onClick={() => {
          setOpenModal(true);
        }}
        icon={TrashIcon}
        title="حذف حساب بانکی متصل"
      />
      <ActionModal
        open={openModal}
        setOpen={setOpenModal}
        icon={TrashIcon}
        title="حذف حساب بانکی متصل"
        description="آيا از حذف حساب بانکی متصل (پس‌انداز خودکار) خود مطمئن هستید؟"
        isContained={false}
        actionTitle="حذف"
        action={deleteContract}
        cancelTitle="بستن"
        loading={loading}
      />
    </CustomDrawer>
  );
}
